import { SCRIPT } from "callable-data-objects";
import { CallableInput } from "Components/Shared";
import CodeArea from "Components/Shared/CodeArea";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Divider, Form, Header, Segment } from "semantic-ui-react";

const CreateScriptForm = () => {
  const { save, nextExtension, validateExtension, validateName } = useDevice();

  const initValues = {
    type: SCRIPT,
    name: "",
    extension: nextExtension,
    script: {
      code: `var HashMap = Java.type("java.util.HashMap")
var hm = new HashMap();
hm.put("from", "12345");
hm;`,
      connectTo: "HANGUP",
    },
  };

  return (
    <Segment>
      <Header as='h3'>Create Script</Header>
      <Divider />
      <Formik
        initialValues={initValues}
        // validationSchema={getDeviceSchema(SCRIPT)}
        onSubmit={(values, actions) => {
          save(values);
        }}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Field
              name='name'
              label='Name'
              validate={validateName}
              component={CallableInput}
            />
            <Field
              name='extension'
              label='Extension'
              placeholder='100'
              type='number'
              validate={validateExtension}
              component={CallableInput}
            />
            <Field name='script.code' label='Code' component={CodeArea} />
            <FormSubmit name='Create Script' errors={props.errors} />
          </Form>
        )}
      </Formik>
    </Segment>
  );
};

export default CreateScriptForm;
